export default __webpack_public_path__ + "static/media/Oval.71fe1615.png";